import * as React from 'react';
import VideoCameraOutlined from './video-camera-outlined';
import VideoCameraFilled from './video-camera-filled';
import type { IconCombinedProps } from './types';
const VideoCameraCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <VideoCameraFilled ref={ref} {...rest} />;
  }
  return <VideoCameraOutlined ref={ref} {...rest} />;
});
export default VideoCameraCombined;